/* eslint-disable no-case-declarations */
import validator from 'validator';
import {
  EXPIRY_CURRENT_MONTH,
  EXPIRY_CURRENT_WEEK,
  IMMEDIATE,
  ORDER_TYPE_M,
  PERCENT_VALUE,
  POSITIONAL_TYPE_NEXT_DAY,
  SEGMENT_FUTURES,
  SQ_OFF_ALL,
  SQ_OFF_LEG,
  SL_ORDER_PLACEMENT_ADVANCE,
  RE_ENTRY_REPEAT_COMMON,
  ORB_PERCENT,
  ORB_POINT,
  RE_ENTRY_COST,
  TRADING_TYPE_INTRADAY,
} from '@quantiply/common/constants';
import { profitLockAndSlTrailingDefaults } from '../../endpoints-data';
import { configurationsDefault } from './defaultValues';
import { filterMatching } from '../../helpers/config-helpers';
import { uniqueJId } from '../../helpers/unique-id';
import { reEntryIntervalTypeCandleClose } from '../../partials/AlgoConfig/AdvancedSettings/ReEntryAdvancedSettings';
import {
  addItem,
  deleteChildren,
  deleteItem,
  updateItem,
} from '../../components/Tree/utils/manipulator';
import { convertTreeData } from '../../components/Tree/utils/data-converter';
import { duplicateLeg } from '../../components/Tree/utils/duplicate-leg';
import { jIntervalTypeCandleClose } from '../../partials/AlgoConfig/AdvancedSettings/JourneyAdvancedSettings';

const findLoactionByLegid = (id, legs) => {
  let indexPicked = null;
  let found = false;

  const legIndex = legs.findIndex((a) => a.id === id);

  if (legIndex >= 0) {
    indexPicked = legIndex;
    found = true;
  }

  return {
    legIndex: indexPicked,
    found,
  };
};

export const updateAlgoStatus = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : {};

  data.status = action.data.status;

  return {
    data: {
      ...state.data,
      data: data,
    },
  };
};

export const updateSettingsClientIdToggle = (state) => {
  const settings = state.settings;

  settings.clientIdShow = !settings.clientIdShow;

  return settings;
};

export const updateSettingsModifyWhileLive = (state, status) => {
  const settings = state.settings;

  settings.modifyWhileLive = status;

  return settings;
};

export const updateSettingsTerminate = (state, status) => {
  const settings = state.settings;

  settings.terminateStart = status;

  return settings;
};

export const updateSettingsSqOff = (state, status) => {
  const settings = state.settings;

  settings.sqOffStart = status;

  return settings;
};

export const updateSettingsSave = (state, status) => {
  const settings = state.settings;

  settings.saveStart = status;

  return settings;
};

export const updatecreateLegUpdateData = (state, action) => {
  const createLeg = state.createLeg;

  createLeg[action.field] = action.value;

  if (action.field === 'segment') {
    if (action.value === SEGMENT_FUTURES) {
      delete createLeg.side;
      delete createLeg.strike;
      createLeg.expiryTag = EXPIRY_CURRENT_WEEK;
    } else {
      createLeg.side = 'CE';
      createLeg.strike = 'ATM';
      createLeg.expiryTag = EXPIRY_CURRENT_MONTH;
    }
  }

  return createLeg;
};

export const updatecreateValidateCreateLeg = (state) => {
  const createLegErrors = {};

  if (
    state.createLeg.quantity === undefined ||
    state.createLeg.quantity === 0 ||
    state.createLeg.quantity < 0
  ) {
    createLegErrors.quantity = 'Quantity is required';
  } else if (
    !validator.isInt(state.createLeg.quantity.toString(), { min: 1 })
  ) {
    createLegErrors.quantity = 'Invalid max matching diff';
  }

  return createLegErrors;
};

export const updateCreateLeg = (state, legData) => {
  const data = state.data && state.data.data ? state.data.data : {};

  if (data.configurations.isWaitAndTradeEnabled) {
    legData.waitAndTrade = {
      type: IMMEDIATE,
      value: 0,
    };
  }

  if (!data.configurations.legs) {
    data.configurations.legs = [legData];
  } else {
    data.configurations.legs = [...data.configurations.legs, legData];
  }

  return {
    data: {
      ...state.data,
      data: {
        ...data,
      },
    },
  };
};

const selectionTypeCleanup = (data, action, legIndex) => {
  const { value = 'STRIKE' } = action || {};

  if (value !== 'STRIKE') {
    data.configurations.legs[legIndex].specificStrikeSelection = false;
    delete data.configurations.legs[legIndex].strike;
  }

  if (value !== 'PREMIUM') {
    delete data.configurations.legs[legIndex].premium;
  }

  if (value !== 'ATM_PERCENT') {
    delete data.configurations.legs[legIndex].atmPercent;
  }

  if (value !== 'STRADDLE_WIDTH') {
    delete data.configurations.legs[legIndex].straddleWidth;
  }

  if (value !== 'STRADDLE_PREMIUM') {
    delete data.configurations.legs[legIndex].straddlePremium;
  }

  if (value !== 'UNDERLYING_PC') {
    delete data.configurations.legs[legIndex].underlyingPC;
  }

  if (value !== 'SP') {
    delete data.configurations.legs[legIndex].sp;
  }

  return data;
};

function targetCleanupJourney(data, legIndex, type) {
  const isMainLeg = data.configurations.legs[legIndex].parentId ? false : true;

  const parentLegId = isMainLeg
    ? data.configurations.legs[legIndex].id
    : data.configurations.legs[legIndex].parentId;

  const parentLegIndex = data.configurations.legs.findIndex(
    (item) => item.id === parentLegId
  );

  const isJourney = data.configurations.legs[parentLegIndex].isJourney
    ? true
    : false;

  const legId = data.configurations.legs[legIndex].id;
  const jLegId = data.configurations.legs[legIndex].parentId
    ? data.configurations.legs[legIndex].id
    : 'root';

  if (parentLegIndex > -1 && isJourney) {
    const journeyLegsToDeleteIds = [];

    const targteItems = data.configurations.legs[
      parentLegIndex
    ]?.journeyTree?.filter((item) => item.value === jLegId);

    for (let index = 0; index < targteItems?.length; index++) {
      const element = targteItems[index];

      const childrenIds = element.children;

      if (!childrenIds?.length) {
        continue;
      }

      const targetItem = data.configurations.legs[parentLegIndex]?.journeyTree
        ?.filter((item) => childrenIds.includes(item._id))
        ?.find((item) => item.type === type);

      if (!targetItem) {
        continue;
      }

      journeyLegsToDeleteIds.push(targetItem._id);
    }

    if (isMainLeg) {
      const rootTargetElement = data.configurations.legs[
        parentLegIndex
      ]?.journeyTree
        ?.filter((item) => !item.parent)
        ?.find((item) => item.type === type);

      if (rootTargetElement) {
        journeyLegsToDeleteIds.push(rootTargetElement._id);
      }
    }

    let journeyTree =
      data.configurations.legs[parentLegIndex].journeyTree || [];

    journeyLegsToDeleteIds.forEach((journeyLegsToDeleteId) => {
      journeyTree = deleteItem(journeyTree, journeyLegsToDeleteId, '_id');
    });

    data.configurations.legs[parentLegIndex].journeyTree = [...journeyTree];

    data.configurations.legs[parentLegIndex].updatedAtJourney = Date.now();

    if (isMainLeg) {
      const isSubordinate =
        type === 'target'
          ? data.configurations.legs[parentLegIndex].stoploss?.value
          : data.configurations.legs[parentLegIndex].target?.value;

      if (!isSubordinate) {
        delete data.configurations.legs[parentLegIndex].isJourney;
        delete data.configurations.legs[parentLegIndex].journeyTree;

        data.configurations.legs = [
          ...data.configurations.legs.filter(
            (item) => item?.parentId !== legId
          ),
        ];
      }
    }
  }

  return data;
}

// add missing journey legs
function targetAddJourney(data, legIndex, type) {
  const isMainLeg = data.configurations.legs[legIndex].parentId ? false : true;

  const parentLegId = isMainLeg
    ? data.configurations.legs[legIndex].id
    : data.configurations.legs[legIndex].parentId;

  const parentLegIndex = data.configurations.legs.findIndex(
    (item) => item.id === parentLegId
  );

  const isJourney = data.configurations.legs[parentLegIndex].isJourney
    ? true
    : false;

  const jLegId = data.configurations.legs[legIndex].parentId
    ? data.configurations.legs[legIndex].id
    : 'root';

  let journeyTree = data.configurations.legs[parentLegIndex].journeyTree || [];

  if (parentLegIndex > -1 && isJourney) {
    const journeyLegsItems = data.configurations.legs[
      parentLegIndex
    ]?.journeyTree?.filter((item) => item.value === jLegId);

    for (let index = 0; index < journeyLegsItems.length; index++) {
      const element = journeyLegsItems[index];

      const childrenIds = element.children;

      if (!childrenIds?.length) {
        journeyTree = addItem(
          journeyTree,
          element._id,
          {
            type,
            value: 'STOP',
            jId: uniqueJId(),
          },
          '_id'
        );

        continue;
      }

      const isMatchInChildren = data.configurations.legs[
        parentLegIndex
      ]?.journeyTree
        ?.filter((item) => childrenIds.includes(item._id))
        .some((item) => item.type === type);

      if (isMatchInChildren) {
        continue;
      }

      const childrenId = childrenIds[0];

      // jid
      const flipType = type === 'stoploss' ? 'target' : 'stoploss';
      const jId = data.configurations.legs[parentLegIndex].journeyTree?.find(
        (item) => item.type === flipType && item._id === childrenId
      )?.jId;

      journeyTree = addItem(
        journeyTree,
        element._id,
        {
          type,
          value: 'STOP',
          jId,
        },
        '_id'
      );
    }

    if (isMainLeg) {
      const isExists = data.configurations.legs[parentLegIndex]?.journeyTree
        ?.filter((item) => !item.parent)
        .some((item) => item.type === type);

      if (!isExists) {
        journeyTree = addItem(
          journeyTree,
          null,
          {
            type,
            value: 'STOP',
            id: `root#1`,
          },
          '_id'
        );
      }
    }

    data.configurations.legs[parentLegIndex].journeyTree = [...journeyTree];
    data.configurations.legs[parentLegIndex].updatedAtJourney = Date.now();
  }

  return data;
}

const processUpdateConfigLegUpdateData = (data, action, legIndex) => {
  const isBulkEditLeg = data.configurations.legs?.some(
    (item) => item.id === action?.id && item?.isBulkEditLeg
  );

  const selectedLegs = data.configurations.legs
    .filter((item) => item.selected)
    .map((item) => item?.id);

  if (isBulkEditLeg && selectedLegs.length) {
    for (let index = 0; index < data.configurations.legs.length; index++) {
      const element = data.configurations.legs[index];

      if (!selectedLegs.includes(element.id)) {
        continue;
      }

      const isReEntryRecost =
        element?.reEntry?.type === RE_ENTRY_COST ? true : false;

      const isJourney = element?.isJourney ? true : false;

      const entryStarted = action.livePositions?.length
        ? action.livePositions
            .filter((p) => p.id === element.id)
            .every((p) => p.entryStarted === true)
        : false;

      const isTradeClosed =
        action.algoMainStatus === 'TRADE_CLOSED' ? true : false;

      if (action.field === 'trailingStoploss') {
        const pos = action.livePositions
          .filter((p) => p.id === element.id)
          .map(({ status = '' }) => status);

        if (pos.length && pos.every((status) => status === 'CLOSE')) {
          continue;
        }
      }

      if (action.field === 'target' || action.field === 'stoploss') {
        const pos = action.livePositions
          .filter((p) => p.id === element.id)
          .map(({ status = '' }) => status);

        if (pos.length && pos.every((status) => status === 'CLOSE')) {
          continue;
        }

        if (action.algoRunning && isJourney && action.value === 'none') {
          continue;
        }
      }

      if (action.field === 'targetReEntry' || action.field === 'reEntry') {
        const pos = action.livePositions
          .filter((p) => p.id === element.id)
          .map(({ status = '' }) => status);

        if (pos.length && pos.every((status) => status === 'CLOSE')) {
          continue;
        }

        const reEntryDisabled = isTradeClosed || isJourney ? true : false;

        if (reEntryDisabled) {
          continue;
        }
      }

      if (action.field === 'waitAndTrade') {
        const latestLeg =
          action.livePositions.find((p) => p.id === element.id && p.latest) ||
          {};

        const isWaitandTradeInLatestLeg =
          latestLeg.waitAndTrade && latestLeg.waitAndTrade.type ? true : false;

        const isReentryLegDisabled =
          action.livePositions.length &&
          !isWaitandTradeInLatestLeg &&
          isReEntryRecost &&
          !isTradeClosed
            ? true
            : false;

        const entryStartedMod = entryStarted && !isTradeClosed;

        if (isReentryLegDisabled || entryStartedMod) {
          continue;
        }
      }

      if (action.field === 'trailingStoploss' && !element.stoploss) {
        continue;
      }

      // if (action.field === 'premium-inc') {

      //   element.premium = {
      //     ...element.premium,
      //     value: action.value.value,
      //   };
      // }

      if (!element.side) {
        if (action.field === 'side') {
          continue;
        }

        if (action.field === 'selectionType') {
          continue;
        }

        if (action.field === 'selectionType') {
          continue;
        }

        if (action.field === 'specificStrikeSelection') {
          continue;
        }

        if (action.field === 'strike') {
          continue;
        }

        if (action.field === 'premium') {
          continue;
        }

        if (action.field === 'atmPercent') {
          continue;
        }

        if (action.field === 'straddleWidth') {
          continue;
        }

        if (action.field === 'straddlePremium') {
          continue;
        }
      }

      element[action.field] = action.value;
    }
  }

  switch (action.field) {
    case 'selectionType':
      data = selectionTypeCleanup(data, action, legIndex);

      if (isBulkEditLeg && selectedLegs.length) {
        for (let index = 0; index < data.configurations.legs.length; index++) {
          const element = data.configurations.legs[index];

          if (!selectedLegs.includes(element.id)) {
            continue;
          }

          data = selectionTypeCleanup(data, action, index);
        }
      }
      break;
    case 'waitAndTrade':
      if (action.value.type === 'IMMEDIATE') {
        data.configurations.legs[legIndex].waitAndTrade.value = 0;

        if (isBulkEditLeg && selectedLegs.length) {
          for (
            let index = 0;
            index < data.configurations.legs.length;
            index++
          ) {
            const element = data.configurations.legs[index];

            if (!selectedLegs.includes(element.id)) {
              continue;
            }

            element.waitAndTrade.value = 0;
          }
        }
      }
      break;
    case 'target':
      if (action.value.type === 'none') {
        delete data.configurations.legs[legIndex].target;

        const allAreTgrNone = data.configurations.legs.every((l) => !l.target);

        if (allAreTgrNone) {
          for (
            let index = 0;
            index < data.configurations.legs.length;
            index++
          ) {
            const element = data.configurations.legs[index];
            delete element.targetReEntry;
          }
        } else if (
          data.configurations.legsAction &&
          data.configurations.legsAction === SQ_OFF_LEG
        ) {
          delete data.configurations.legs[legIndex].targetReEntry;

          if (isBulkEditLeg && selectedLegs.length) {
            for (
              let index = 0;
              index < data.configurations.legs.length;
              index++
            ) {
              const element = data.configurations.legs[index];

              if (!selectedLegs.includes(element.id)) {
                continue;
              }

              delete element.targetReEntry;
              delete element.target;
            }
          }
        }
      }

      if (action.value.type === 'none') {
        data = targetCleanupJourney(data, legIndex, 'target');

        if (isBulkEditLeg && selectedLegs.length) {
          for (
            let index = 0;
            index < data.configurations.legs.length;
            index++
          ) {
            data = targetCleanupJourney(data, index, 'target');
          }
        }
      } else if (action.value.type !== 'none' && action.value.value) {
        data = targetAddJourney(data, legIndex, 'target');

        if (isBulkEditLeg && selectedLegs.length) {
          for (
            let index = 0;
            index < data.configurations.legs.length;
            index++
          ) {
            data = targetAddJourney(data, index, 'target');
          }
        }
      }
      break;
    case 'stoploss':
      if (action.value.type === 'none') {
        delete data.configurations.legs[legIndex].stoploss;
        delete data.configurations.legs[legIndex].trailingStoploss;

        const allAreSlNone = data.configurations.legs.every((l) => !l.stoploss);

        if (allAreSlNone) {
          for (
            let index = 0;
            index < data.configurations.legs.length;
            index++
          ) {
            const element = data.configurations.legs[index];
            delete element.reEntry;
          }
        } else if (
          data.configurations.legsAction &&
          data.configurations.legsAction === SQ_OFF_LEG
        ) {
          delete data.configurations.legs[legIndex].reEntry;

          if (isBulkEditLeg && selectedLegs.length) {
            for (
              let index = 0;
              index < data.configurations.legs.length;
              index++
            ) {
              const element = data.configurations.legs[index];

              if (!selectedLegs.includes(element.id)) {
                continue;
              }

              delete element.reEntry;
              delete element.stoploss;
              delete element.trailingStoploss;
            }
          }
        }
      }

      if (action.value.type === 'none') {
        data = targetCleanupJourney(data, legIndex, 'stoploss');

        if (isBulkEditLeg && selectedLegs.length) {
          for (
            let index = 0;
            index < data.configurations.legs.length;
            index++
          ) {
            data = targetCleanupJourney(data, index, 'stoploss');
          }
        }
      } else if (action.value.type !== 'none' && action.value.value) {
        data = targetAddJourney(data, legIndex, 'stoploss');

        if (isBulkEditLeg && selectedLegs.length) {
          for (
            let index = 0;
            index < data.configurations.legs.length;
            index++
          ) {
            data = targetAddJourney(data, index, 'stoploss');
          }
        }
      }
      break;
    case 'trailingStoploss':
      if (action.value.type === 'none') {
        delete data.configurations.legs[legIndex].trailingStoploss;

        if (isBulkEditLeg && selectedLegs.length) {
          for (
            let index = 0;
            index < data.configurations.legs.length;
            index++
          ) {
            const element = data.configurations.legs[index];

            if (!selectedLegs.includes(element.id)) {
              continue;
            }

            delete element.trailingStoploss;
          }
        }
      }
      break;
    case 'reEntry':
      if (
        data.configurations.legsAction &&
        data.configurations.legsAction === SQ_OFF_ALL
      ) {
        for (let index = 0; index < data.configurations.legs.length; index++) {
          const element = data.configurations.legs[index];

          if (action.value.type === 'none') {
            delete element.reEntry;
          } else {
            element.reEntry = action.value;

            if (
              data.configurations.positionReEntryRepeatMode &&
              data.configurations.positionReEntryRepeatMode ===
                RE_ENTRY_REPEAT_COMMON &&
              element.targetReEntry
            ) {
              element.targetReEntry.repeat = action.value.repeat;
            }
          }
        }
      } else {
        if (action.value.type === 'none') {
          delete data.configurations.legs[legIndex].reEntry;

          if (isBulkEditLeg && selectedLegs.length) {
            for (
              let index = 0;
              index < data.configurations.legs.length;
              index++
            ) {
              const element = data.configurations.legs[index];

              if (!selectedLegs.includes(element.id)) {
                continue;
              }

              delete element.reEntry;
            }
          }
        } else if (
          data.configurations.positionReEntryRepeatMode &&
          data.configurations.positionReEntryRepeatMode ===
            RE_ENTRY_REPEAT_COMMON &&
          data.configurations.legs[legIndex].targetReEntry
        ) {
          data.configurations.legs[legIndex].targetReEntry.repeat =
            action.value.repeat;
        }
      }

      break;
    case 'targetReEntry':
      if (
        data.configurations.legsAction &&
        data.configurations.legsAction === SQ_OFF_ALL
      ) {
        for (let index = 0; index < data.configurations.legs.length; index++) {
          const element = data.configurations.legs[index];
          if (action.value.type === 'none') {
            delete element.targetReEntry;
          } else {
            element.targetReEntry = action.value;

            if (
              data.configurations.positionReEntryRepeatMode &&
              data.configurations.positionReEntryRepeatMode ===
                RE_ENTRY_REPEAT_COMMON &&
              element.reEntry
            ) {
              element.reEntry.repeat = action.value.repeat;
            }
          }
        }
      } else {
        if (action.value.type === 'none') {
          delete data.configurations.legs[legIndex].targetReEntry;

          if (isBulkEditLeg && selectedLegs.length) {
            for (
              let index = 0;
              index < data.configurations.legs.length;
              index++
            ) {
              const element = data.configurations.legs[index];

              if (!selectedLegs.includes(element.id)) {
                continue;
              }

              delete element.targetReEntry;
            }
          }
        } else if (
          data.configurations.positionReEntryRepeatMode &&
          data.configurations.positionReEntryRepeatMode ===
            RE_ENTRY_REPEAT_COMMON &&
          data.configurations.legs[legIndex].reEntry
        ) {
          data.configurations.legs[legIndex].reEntry.repeat =
            action.value.repeat;

          if (isBulkEditLeg && selectedLegs.length) {
            for (
              let index = 0;
              index < data.configurations.legs.length;
              index++
            ) {
              const element = data.configurations.legs[index];

              if (!selectedLegs.includes(element.id)) {
                continue;
              }

              if (element.reEntry?.repeat) {
                element.reEntry.repeat = action.value.repeat;
              }
            }
          }
        }
      }
      break;
    case 'isJourney':
      if (!action.value) {
        delete data.configurations.legs[legIndex].isJourney;
        delete data.configurations.legs[legIndex].journeyTree;

        const legId = data.configurations.legs[legIndex]?.id;

        const filteredLegs = data.configurations.legs?.filter(
          (item) => item?.parentId !== legId
        );

        data.configurations.legs = [...filteredLegs];

        if (data.configurations.legs && data.configurations.legs.length) {
          for (
            let index = 0;
            index < data.configurations.legs.length;
            index++
          ) {
            const element = data.configurations.legs[index];
            delete element.reEntry;
            delete element.targetReEntry;
          }
        }

        if (data.configurations.isReEntryEnabled) {
          data.configurations.isReEntryEnabled = false;
        }

        delete data.configurations.reEntry;
        delete data.configurations.targetReEntry;
        delete data.configurations.reEntryInterval;
        delete data.configurations.reEntryAfter;
        delete data.configurations.reEntryBefore;
        delete data.configurations.reEntryAsapOrderDelay;
        delete data.configurations.reEntryOrderPlacement;
      } else {
        const isAnyJourney =
          data.configurations.legs.filter((item) => item.isJourney).length > 1
            ? true
            : false;

        data.configurations.legs[legIndex].isJourney = true;
        data.configurations.legs[legIndex].journeyTree = [];

        const defaultJourneyData = {};

        // isTarget
        if (data.configurations.legs[legIndex]?.target?.value) {
          defaultJourneyData['root#1:target'] = 'STOP';
        }

        // isStoploss
        if (data.configurations.legs[legIndex]?.stoploss?.value) {
          defaultJourneyData['root#1:stoploss'] = 'STOP';
        }

        data.configurations.legs[legIndex].journeyTree =
          convertTreeData(defaultJourneyData);

        if (!isAnyJourney) {
          data.configurations.jInterval = jIntervalTypeCandleClose;
        }
      }
      break;
    default:
    // code block
  }

  return data;
};

export const updateConfigLegUpdateData = (state, action) => {
  let data = state.data && state.data.data ? state.data.data : {};

  const { found, legIndex } = findLoactionByLegid(
    action.id,
    data.configurations.legs
  );

  if (found) {
    data.configurations.legs[legIndex][action.field] = action.value;

    data = processUpdateConfigLegUpdateData(data, action, legIndex);
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
  };
};

export const updatePositionModaldata = (state, action, status) => {
  const positionTableModals = state.positionTableModals;

  if (positionTableModals[action.name]) {
    if (status) {
      positionTableModals[action.name].open = true;
      positionTableModals[action.name].data = action.data;
    } else {
      positionTableModals[action.name].open = false;
      positionTableModals[action.name].data = {};
    }
  }

  return positionTableModals;
};

const processUpdateConfigurationUpdateData = (data, action) => {
  switch (action.field) {
    case 'isWaitAndTradeEnabled':
      if (
        !data.configurations.isORBEnabled &&
        data.configurations.tradeOnlyFirstEntry
      ) {
        data.configurations.tradeOnlyFirstEntry = false;
      }

      if (action.value === true) {
        const newMatching = filterMatching(
          data.configurations.matching,
          'NO_MATCHING',
          true
        );

        data.configurations.matching = newMatching;

        for (let index = 0; index < data.configurations.legs.length; index++) {
          if (!data.configurations.legs[index].waitAndTrade) {
            data.configurations.legs[index].waitAndTrade = {
              type: 'IMMEDIATE',
              value: 0,
            };
          }
        }
      } else {
        for (let index = 0; index < data.configurations.legs.length; index++) {
          delete data.configurations.legs[index].waitAndTrade;
        }

        if (!data.configurations.isORBEnabled) {
          delete data.configurations.mDayInitEntry;
        }
      }
      break;
    case 'isORBEnabled':
      if (
        !data.configurations.isWaitAndTradeEnabled &&
        data.configurations.tradeOnlyFirstEntry
      ) {
        data.configurations.tradeOnlyFirstEntry = false;
      }

      if (action.value === true) {
        if (!data.configurations.orbEndTime) {
          data.configurations.orbEndTime = '09:16:00';
        }

        if (!data.configurations.isWaitAndTradeEnabled) {
          for (
            let index = 0;
            index < data.configurations.legs.length;
            index++
          ) {
            delete data.configurations.legs[index].waitAndTrade;
          }
        }
      } else {
        if (data.configurations.legs && data.configurations.legs.length) {
          for (
            let index = 0;
            index < data.configurations.legs.length;
            index++
          ) {
            const element = data.configurations.legs[index];

            if (element?.stoploss?.type) {
              if (
                element.stoploss.type === ORB_PERCENT ||
                element.stoploss.type === ORB_POINT
              ) {
                delete element.stoploss;
              }
            }

            if (element?.traget?.type) {
              if (
                element.traget.type === ORB_PERCENT ||
                element.traget.type === ORB_POINT
              ) {
                delete element.traget;
              }
            }

            delete element.orb;
          }

          delete data.configurations.orbEndTime;
        }

        if (!data.configurations.isWaitAndTradeEnabled) {
          delete data.configurations.mDayInitEntry;
        }
      }
      break;
    case 'isReEntryEnabled':
      // eslint-disable-next-line no-empty
      if (action.value === true) {
      } else {
        if (data.configurations.legs && data.configurations.legs.length) {
          for (
            let index = 0;
            index < data.configurations.legs.length;
            index++
          ) {
            const element = data.configurations.legs[index];
            delete element.reEntry;
            delete element.targetReEntry;
          }
        }

        delete data.configurations.reEntry;
        delete data.configurations.targetReEntry;
        delete data.configurations.reEntryInterval;
        delete data.configurations.reEntryAfter;
        delete data.configurations.reEntryBefore;
        delete data.configurations.reEntryAsapOrderDelay;
        delete data.configurations.reEntryOrderPlacement;
        delete data.configurations.reEntryReCostActType;
      }
      break;
    case 'reEntryInterval':
      if (action.value === '') {
        delete data.configurations.reEntryInterval;
      }

      if (action.value === reEntryIntervalTypeCandleClose) {
        delete data.configurations.reEntryOrderPlacement;
      }

      break;
    case 'jInterval':
      if (action.value === '') {
        delete data.configurations.jInterval;
      }

      break;
    case 'jBefore':
      if (action.value === '') {
        delete data.configurations.jBefore;
      }

      break;
    case 'jAfter':
      if (action.value === '') {
        delete data.configurations.jAfter;
      }

      break;
    case 'tradingType':
      data.configurations.positionalType = POSITIONAL_TYPE_NEXT_DAY;
      data.configurations.endTime = '15:15:00';
      data.configurations.actionTime = '09:16:00';
      data.configurations.endDay = 0;

      if (action.value === TRADING_TYPE_INTRADAY) {
        delete data.configurations.mDayInitEntry;
      }

      break;
    case 'positionalType':
      data.configurations.endTime = '15:15:00';
      data.configurations.endDay = 0;
      break;
    case 'target':
      if (action.value.type === 'none') {
        delete data.configurations.target;
        delete data.configurations.targetReEntry;
      }
      break;
    case 'stoploss':
      if (action.value.type === 'none') {
        delete data.configurations.stoploss;
        delete data.configurations.reEntry;
      }
      break;
    case 'reEntry':
      if (action.value.type === 'none') {
        delete data.configurations.reEntry;
      } else if (
        data.configurations.mtmReEntryRepeatMode &&
        data.configurations.mtmReEntryRepeatMode === RE_ENTRY_REPEAT_COMMON &&
        data.configurations.targetReEntry &&
        data.configurations.targetReEntry.type &&
        data.configurations.targetReEntry.type !== 'none'
      ) {
        data.configurations.targetReEntry.repeat = action.value.repeat;
      }
      break;
    case 'targetReEntry':
      if (action.value.type === 'none') {
        delete data.configurations.targetReEntry;
      } else if (
        data.configurations.mtmReEntryRepeatMode &&
        data.configurations.mtmReEntryRepeatMode === RE_ENTRY_REPEAT_COMMON &&
        data.configurations.reEntry &&
        data.configurations.reEntry.type &&
        data.configurations.reEntry.type !== 'none'
      ) {
        data.configurations.reEntry.repeat = action.value.repeat;
      }
      break;
    case 'matching':
      const { active: noMatchingActive = false } =
        action.value.find((a) => a.mode === 'NO_MATCHING') || {};

      if (
        noMatchingActive &&
        data.configurations.legs &&
        data.configurations.legs.length
      ) {
        for (let index = 0; index < data.configurations.legs.length; index++) {
          const element = data.configurations.legs[index];

          element.mp = false;
        }
      }
      break;
    case 'entryOrderType':
      if (action.value === ORDER_TYPE_M) {
        delete data.configurations.entryOrderLimitPrice;
        delete data.configurations.reEntryOrderPlacement;

        data.configurations.entryOrderTimeoutSeconds = 0;
      } else {
        data.configurations.entryOrderLimitPrice = {
          type: PERCENT_VALUE,
          value: 3,
        };

        if (!data.configurations.entryOrderTimeoutSeconds) {
          data.configurations.entryOrderTimeoutSeconds = 0;
        }
      }
      break;
    case 'stoplossSquareOffBy':
      if (action.value === ORDER_TYPE_M) {
        delete data.configurations.stoplossLimitPrice;
        delete data.configurations.stoplossOrderPlacement;

        data.configurations.limitOrderTimeoutSeconds = 0;
        data.configurations.stoplossSquareOffDelay = 0;
      } else {
        data.configurations.stoplossLimitPrice = {
          type: PERCENT_VALUE,
          value: 3,
        };

        if (!data.configurations.limitOrderTimeoutSeconds) {
          data.configurations.limitOrderTimeoutSeconds = 0;
        }

        if (!data.configurations.stoplossOrderPlacement) {
          data.configurations.stoplossOrderPlacement =
            SL_ORDER_PLACEMENT_ADVANCE;
        }

        data.configurations.stoplossSquareOffDelay = 0;
      }

      break;
    case 'entryOrderDelayType':
      if (action.value === null) {
        delete data.configurations.entryOrderDelay;
      }
      break;
    case 'exitOrderDelayType':
      if (action.value === null) {
        delete data.configurations.exitOrderDelay;
      }
      break;
    case 'legsAction':
      if (data.configurations.legs && data.configurations.legs.length) {
        for (let index = 0; index < data.configurations.legs.length; index++) {
          const element = data.configurations.legs[index];
          delete element.reEntry;
          delete element.targetReEntry;
        }
      }
      break;
    case 'stoplossOrderPlacement':
      if (action.value === SL_ORDER_PLACEMENT_ADVANCE) {
        data.configurations.stoplossSquareOffDelay = 0;
      } else {
        if (!data.configurations.stoplossSquareOffDelay) {
          data.configurations.stoplossSquareOffDelay = 0;
        }
      }
      break;
    case 'positionReEntryRepeatMode':
      if (
        action.value === RE_ENTRY_REPEAT_COMMON &&
        data.configurations.legs &&
        data.configurations.legs.length
      ) {
        for (let index = 0; index < data.configurations.legs.length; index++) {
          const element = data.configurations.legs[index];

          if (element.reEntry) {
            element.reEntry.repeat = 0;
          }

          if (element.targetReEntry) {
            element.targetReEntry.repeat = 0;
          }
        }
      }
      break;
    case 'mtmReEntryRepeatMode':
      if (action.value === RE_ENTRY_REPEAT_COMMON) {
        if (data.configurations.reEntry) {
          data.configurations.reEntry.repeat = 0;
        }

        if (data.configurations.targetReEntry) {
          data.configurations.targetReEntry.repeat = 0;
        }
      }

      break;
    case 'mInterval':
      if (action.value === '') {
        delete data.configurations.mInterval;
      }

      break;
    case 'reEntryReCostActType':
      if (action.value === '') {
        delete data.configurations.reEntryReCostActType;
      }

      break;
    default:

    // code block
  }

  return data;
};

export const updateConfigurationUpdateData = (state, action) => {
  let data = state.data && state.data.data ? state.data.data : {};

  data.configurations[action.field] = action.value;
  data = processUpdateConfigurationUpdateData(data, action);

  return {
    data: {
      ...state.data,
      data: data,
    },
  };
};

export const updateConfigurationDeleteLegUpdateData = (state, action) => {
  let data = state.data && state.data.data ? state.data.data : {};

  const newLegs = [];

  const parentId = data.configurations.legs.find(
    (item) => item.id === action.id
  )?.parentId;

  for (let index = 0; index < data.configurations.legs.length; index++) {
    const leg = data.configurations.legs[index];

    // match
    if (leg.id === action.id) {
      continue;
    }

    if (leg.parentId === action.id) {
      continue;
    }

    leg.updatedAtJourney = Date.now();

    newLegs.push(leg);
  }

  const parentLeg = newLegs.find((item) => item.id == parentId);
  const targetLeg = data.configurations.legs.find(
    (item) => item.id === action.id
  );

  if (parentLeg && targetLeg) {
    let journeyTree = parentLeg?.journeyTree || [];

    const itemsToBecleared = journeyTree
      .filter((item) => item.value === targetLeg.id)
      .map((item) => item._id);

    for (let index = 0; index < itemsToBecleared.length; index++) {
      const itemToBecleared = itemsToBecleared[index];

      journeyTree = deleteChildren(journeyTree, itemToBecleared, '_id');

      journeyTree = updateItem(
        journeyTree,
        itemToBecleared,
        {
          value: 'STOP',
        },
        '_id'
      );
    }

    const parentLegIndex = newLegs.findIndex((item) => item.id == parentId);

    if (parentLegIndex >= 0) {
      newLegs[parentLegIndex].journeyTree = [...journeyTree];
    }
  }

  data.configurations.legs = newLegs;

  return {
    data: {
      ...state.data,
      data: data,
    },
  };
};

export const updateConfigurationDuplicateLegUpdateData = (state, action) => {
  let data = state.data && state.data.data ? state.data.data : {};

  const targetIndex = data.configurations.legs.findIndex(
    (l) => l.id === action.id
  );

  if (targetIndex < 0) {
    return {
      data: {
        ...state.data,
        data: data,
      },
    };
  }

  data.configurations.legs = [
    ...duplicateLeg(data.configurations.legs || [], action.id),
  ];

  return {
    data: {
      ...state.data,
      data: data,
    },
  };
};

export const updateProfitLockTrailingSl = (state, action) => {
  let data = state.data && state.data.data ? state.data.data : {};

  const allArray = [
    'trailingStoploss',
    'lockProfit',
    'trailProfit',
    'lockTrailProfit',
  ];

  for (let index = 0; index < allArray.length; index++) {
    const element = allArray[index];

    if (action.value === 'none' && data.configurations[element]) {
      delete data.configurations[element];
    } else {
      if (action.value === element) {
        if (!data.configurations[element]) {
          data.configurations[element] =
            profitLockAndSlTrailingDefaults[element];
        }
      } else {
        if (data.configurations[element]) {
          delete data.configurations[element];
        }
      }
    }
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
  };
};

export const updateSettingsLoading = (state, status) => {
  const settings = state.settings;

  settings.loading = status;

  return settings;
};

const processUpdatePreSaveConfigFix = (data) => {
  const {
    reEntryAfter = '',
    reEntryBefore = '',
    jAfter = '',
    jBefore = '',
    legs,
  } = data.configurations;
  const [HHreEntryAfter, MMreEntryAfter, SSreEntryAfter] =
    reEntryAfter.split(':');

  const [HHreEntryBefore, MMreEntryBefore, SSreEntryBefore] =
    reEntryBefore.split(':');

  if (!HHreEntryAfter || !MMreEntryAfter || !SSreEntryAfter) {
    delete data.configurations.reEntryAfter;
  }

  if (!HHreEntryBefore || !MMreEntryBefore || !SSreEntryBefore) {
    delete data.configurations.reEntryBefore;
  }

  const [HHjAfter, MMjAfter, SSjAfter] = jAfter.split(':');

  const [HHrejBefore, MMrejBefore, SSrejBefore] = jBefore.split(':');

  if (!HHjAfter || !MMjAfter || !SSjAfter) {
    delete data.configurations.jAfter;
  }

  if (!HHrejBefore || !MMrejBefore || !SSrejBefore) {
    delete data.configurations.jBefore;
  }

  if (!legs || (legs && !legs.length)) {
    data.configurations.legs = [];
  }

  return data;
};

export const updatePreSaveConfigFix = (state) => {
  let data = state.data && state.data.data ? state.data.data : {};

  data = processUpdatePreSaveConfigFix(data);

  return {
    data: {
      ...state.data,
      data: data,
    },
  };
};

const processUpdateConfigurationDecorator = (data) => {
  const { startTime = '' } = data.configurations;

  if (!startTime) {
    data.configurations = configurationsDefault;
  }

  return data;
};

export const updateConfigurationDecorator = (state) => {
  let data = state.data && state.data.data ? state.data.data : {};

  data = processUpdateConfigurationDecorator(data);

  return {
    data: {
      ...state.data,
      data: data,
    },
  };
};

export const updateNameChange = (state, action) => {
  let data = state.data && state.data.data ? state.data.data : {};

  data.name = action.value;

  return {
    data: {
      ...state.data,
      data: data,
    },
  };
};

export const updateConfigSave = (state, status) => {
  const settings = state.settings;

  settings.configSave = status;

  return settings;
};

export const updateCreateModalOpen = (state, status) => {
  const settings = state.settings;

  settings.openCreateModal = status;

  return settings;
};

export const updateConfigLegMultiSelect = (state, action) => {
  let data = state.data && state.data.data ? state.data.data : {};

  for (let index = 0; index < data.configurations.legs.length; index++) {
    const element = data.configurations.legs[index];

    if (element.isBulkEditLeg) {
      continue;
    }

    if (element.parentId) {
      continue;
    }

    element.selected = action.select;
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
  };
};

export const updateConfigLegPremiumInputIncrement = (state, action) => {
  let data = state.data && state.data.data ? state.data.data : {};

  let indexValue = 0;

  for (let index = 0; index < data.configurations.legs.length; index++) {
    const element = data.configurations.legs[index];

    if (!element.selected) {
      continue;
    }

    if (element.selectionType !== 'PREMIUM') {
      continue;
    }

    if (!element?.premium) {
      continue;
    }

    if (element?.premium?.type !== action.field) {
      continue;
    }

    element.premium = {
      ...element.premium,
      value: (element?.premium?.value || 0) + indexValue * action.value,
    };

    indexValue += 1;
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
  };
};
